import { mainApiAxios as axios } from '@/plugins/axios'


export default {
    listQuestionTypeItems() {
        return axios.get('lookupsAdmin/QuestionTypes')
    },
    listResultTypeItems() {
        return axios.get('lookupsAdmin/ResultTypes')
    },
    listAnalyticsTypeItems() {
        return axios.get('lookupsAdmin/AnalyticsTypes')
    },
    listPatternTypeItems() {
        return axios.get('lookupsAdmin/PatternTypes')
    },
    updateQuestionTypeItems(questionTypeItemId,QuestionTypeObject) {
        return axios.post(`lookupsAdmin/updateQuestionTypeItems/${questionTypeItemId}`, QuestionTypeObject, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },
    updateQuestionTypeItemsOrder(QuestionTypeObject) {
        return axios.post('lookupsAdmin/updateQuestionTypeItemsOrder', QuestionTypeObject, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },
    listLookups() {
        return axios.get('lookupsAdmin')
    }, 
    listNotRelatedLookups() {
        return axios.get('lookupsAdmin/listNotRelatedLookups')
    },
    listSurveyLookups() {
        return axios.get('lookupsAdmin/survey')
    }, 

    listSurveyLookupsByParentId(lookupId) {
        return axios.get(`lookupsAdmin/ListSurveyLookupsByParentId/${lookupId}`)
    },

    updateLookup(lookupId, lookupObj) {
        return axios.post(`lookupsAdmin/updateLookup/${lookupId}`, lookupObj, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },

    deleteLookup(lookupId) {
        return axios.post(`lookupsAdmin/deleteLookup/${lookupId}`)
    },

    listLookupItemsIfHasChild(lookupId) {
        return axios.get(`lookupsAdmin/ListLookupItemsIfHasChild/${lookupId}`, lookupId)
    },

    listSurveyLookupItems(lookupId) {
        return axios.get(`lookupsAdmin/survey/${lookupId}`, lookupId)
    },

    listLookupItems(lookupId) {
        return axios.get(`lookupsAdmin/${lookupId}`, lookupId)
    },
    addLookup(lookupAdmin) {
        return axios.post('lookupsAdmin/Create-Lookup', lookupAdmin, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    addLookupItems(lookupItem) {
        return axios.post('lookupsAdmin/Add-LookupItems', lookupItem, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    updateLookupItem(lookupItemId, lookupItemObj) {
        return axios.post(`lookupsAdmin/updateLookupItem/${lookupItemId}`, lookupItemObj, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },
    deleteLookupItem(lookupId) {
        return axios.post(`lookupsAdmin/deleteLookupItem/${lookupId}`)
    }
}